/** Ported 1:1 from dna-prototype.html — see decision-log.md for the rationale behind each value. */

export const FRAME_COUNT = 90;
export const FRAME_BASE_PATH = '/assets/dna-hub/frames';

export const getFrameUrl = (index: number): string =>
  `${FRAME_BASE_PATH}/frame-${String(index + 1).padStart(3, '0')}.webp`;

export const NATIVE_W = 446;
export const NATIVE_H = 1166;

export const SCALE_MAX_BASE = 1.0;
export const SCALE_MAX_CEILING = 1.27;
export const MIN_OVERFLOW_PX = 250;
export const FIT_MARGIN = 0.94;

export const TRACK_VH = 550;

/**
 * Phase timeline over p (0 -> 1):
 * 1. 0.00 -> P_BLANK_END        blank
 * 2. P_BLANK_END -> P_TEXT_IN_END     headline fades in
 * 3. P_TEXT_IN_END -> P_TEXT_HOLD_END holds
 * 4. P_TEXT_HOLD_END -> P_CROSSFADE_END crossfade: headline out, helix in (rotate+pan already starts here)
 * 5. P_TEXT_HOLD_END -> P_ROTATE_END  rotate + pan
 * 6. P_ROTATE_END -> P_PAUSE_END      breath (static hold)
 * 7. P_PAUSE_END -> 1                 shrink and center
 */
export const P_BLANK_END = 0.05;
export const P_TEXT_IN_END = 0.23;
export const P_TEXT_HOLD_END = 0.33;
export const P_CROSSFADE_END = 0.55;

/** Confirmed final values — extended from an earlier 0.70/0.79 pair; do not change without re-opening the decision log. */
export const P_ROTATE_END = 0.85;
export const P_PAUSE_END = 0.9;

/** 0.5 = helix entry starts offset half a viewport height below its resting pan position. */
export const ENTRY_OFFSET_FACTOR = 0.5;

export const NAV_HEIGHT_PX = 64;
export const GRID_MARGIN_PX = 112;
export const GRID_GUTTER_PX = 16;
export const GRID_COLUMNS = 12;

export const HEADLINE_TEXT =
  'Our unique way of building iconic brands — profoundly human-centric and intensely growth-oriented.';
